namespace GeniuzPOS.ReportMasterData {
    export class Report_1319Columns {
        static columnsKey = 'ReportMasterData.Report_1319';
    }
}
